import React, { Component } from "react";
import social from './assets/social-media.jpg';
import "./assets/crisis.scss";
export default class Crisis extends Component {

  constructor(props) {
    super(props);
    this.childProps = props.props.childProps;
  }

  render() {

    if (this.childProps && this.childProps.header === 'standard') {
      return null;
    };

    return (
      <div className="crisis container-fluid">
        <div className="row">
          <div className="container wrapper">
            <div className="row">

              <div className="row text-center">
                <p className="crisis-content">
                  This website is designed for crisis prevention, need immediate help?
                </p>
                <div className="secondary-cta">
                  <a href="https://www.samaritans.org/">contact samaritans</a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/header/Crisis.js